import TransfersDetails from '../transactions/TransfersDetails';
import { PaymentsGroup } from '../../types/payments';

function CheckoutTransfersSection({
  paymentsGroup,
}: {
  paymentsGroup: PaymentsGroup;
}) {
  return <TransfersDetails payments={paymentsGroup?.payments ?? []} />;
}

export default CheckoutTransfersSection;
